import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import axios from '../../../../library/axios';
import {
  handleJobQueuedSuccess,
  handleJobRequestError,
} from '../../../../helpers/cpanelJobFeedback';

const ExportCpanelTenantComp = ({ close }) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [exportType, setExportType] = useState('csv');
  const [includeDeleted, setIncludeDeleted] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    setDisabled(true);

    try {
      const response = await axios({
        url: `/cpanel/tenants/export?type=${exportType}${includeDeleted ? '&all=true' : ''}`,
        method: 'GET',
      });

      const queued = await handleJobQueuedSuccess({
        response,
        actionLabel: 'Ekspor tenant',
        close,
      });

      if (!queued) {
        close();
      }
    } catch (err) {
      handleJobRequestError(err, 'Tidak dapat memulai ekspor tenant.');
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  return (
    <div>
      <div className="mb-4">
        <label htmlFor="tenantExportType" className="form-label required">
          Format file
        </label>
        <select
          id="tenantExportType"
          className="form-select"
          value={exportType}
          onChange={(e) => setExportType(e.target.value)}
          disabled={disabled}
        >
          <option value="csv">CSV (.csv)</option>
          <option value="xls">Excel (.xls)</option>
          <option value="xlsx">Excel (.xlsx)</option>
        </select>
        <div className="form-text">
          Kolom: <strong>Alamat Akses</strong>, <strong>Slug</strong>, <strong>Database/Filestore</strong>,{' '}
          <strong>Deskripsi</strong>
          {includeDeleted ? (
            <>
              , <strong>Status</strong> (<em>Aktif</em> / <em>Tidak aktif</em>)
            </>
          ) : null}
          .
        </div>
      </div>

      <div className="mb-4">
        <label className="form-check form-check-custom form-check-solid">
          <input
            className="form-check-input"
            type="checkbox"
            checked={includeDeleted}
            onChange={(e) => setIncludeDeleted(e.target.checked)}
            disabled={disabled}
          />
          <span className="form-check-label">Sertakan tenant yang sudah dihapus</span>
        </label>
      </div>

      <div className="alert alert-light border mb-4 py-2 px-3 fs-7 text-muted mb-0">
        File akan siap diunduh setelah job selesai. Cek notifikasi atau halaman Job Runner.
      </div>

      <div className="d-flex justify-content-start gap-2">
        <Button variant="light" size="sm" onClick={close} disabled={disabled}>
          Tutup
        </Button>
        <Button variant="success" size="sm" disabled={disabled} onClick={handleExport}>
          {loading ? 'Memulai job...' : 'Ekspor'}
        </Button>
      </div>
    </div>
  );
};

export default ExportCpanelTenantComp;
